<template>
  <div :class="classPrefix" @mousedown="mousefocus = true" @mouseout="mousefocus = false">
    <md-field>
      <label :class="getLabelClass()">{{placeholder}}</label>
      <md-input
        :disabled="disabled"
        @focus="focused = true"
        @blur="focused = false"
        v-model="search"
        :placeholder="placeholder"
        :class="getInputClass()"
        @keydown.down.prevent.stop="moveDown()"
        @keydown.up.prevent.stop="moveUp()"
        @keydown.enter.prevent.stop="select(selectedIndex)"
        @keydown.tab="select(0)"
        @click="mousefocus = true"
        ref="input"
        :required="required"
        readonly
      ></md-input>
      <slide-y-down-transition>
        <md-icon class="error" v-show="error">close</md-icon>
      </slide-y-down-transition>
    </md-field>
    <div v-if="showSuggestions" :class="classPrefix + '__suggestions'">
      <div
        v-for="(entry, index) in entries"
        @click="select(index)"
        :class="[classPrefix + '__entry', selectedClass(index)]"
      >
        <slot :row="entry">{{ entry[property] }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  name: "ht-select",
  components: { SlideYDownTransition },
  data() {
    return {
      entries: [],
      search: "",
      focused: false,
      mousefocus: false,
      selectedIndex: -1
    };
  },
  computed: {
    filteredEntries() {
      if (this.search.length < this.threshold) {
        return this.entries;
      } else {
        return this.entries.filter(entry => {
          if (this.ignoreCase) {
            return (
              entry[this.property]
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1
            );
          }
          return entry[this.property].indexOf(this.search) > -1;
        });
      }
    },
    hasSuggestions() {
      if (this.search.length < this.threshold) {
        return false;
      }

      return this.entries.length > 0;
    },
    showSuggestions() {
      if (!this.hasSuggestions) {
        return false;
      }

      if (this.focused || this.mousefocus) {
        return true;
      }

      return false;
    }
  },
  created() {
    this.search = this.value;
    if (this.list !== undefined) {
      this.setEntries(this.list);
    } else if (this.url !== undefined && this.requestType !== undefined) {
      this.getListAjax();
    }
    document.addEventListener("click", this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    select(index) {
      //   if (this.hasSuggestions) {
      if (index < this.entries.length) {
        this.selectedIndex = index;

        this.search = this.entries[index][this.property];
        this.$emit("autocomplete-select", this.entries[index]);
        this.$emit("selected", this.entries[index]);
        if (this.autoHide) {
          this.mousefocus = false;
          this.focused = false;
        } else {
          this.$nextTick(() => {
            this.$refs.input.focus();
          });
        }
      }
      //   }
    },
    setEntries(list) {
      this.entries = list;
    },
    moveUp() {
      this.focused = true;
      if (this.selectedIndex - 1 < 0) {
        this.selectedIndex = this.entries.length - 1;
      } else {
        this.selectedIndex -= 1;
      }
    },
    moveDown() {
      this.focused = true;
      if (this.selectedIndex + 1 > this.entries.length - 1) {
        this.selectedIndex = 0;
      } else {
        this.selectedIndex += 1;
      }
    },
    selectedClass(index) {
      if (index === this.selectedIndex) {
        return this.classPrefix + "__selected";
      }

      return "";
    },
    getLabelClass() {
      if (this.error) return "error";
      else return "";
    },
    getInputClass() {
      if (this.error) return "inputClass error";
      else return "inputClass";
    },
    getListAjax() {
      return this.$http[this.requestType](this.url).then(response => {
        this.setEntries(response.data);
      });
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.focused = false;
        this.mousefocus = false;
      }
    }
  },
  props: {
    classPrefix: {
      type: String,
      required: false,
      default: "autocomplete"
    },
    url: {
      type: String,
      required: false
    },
    requestType: {
      type: String,
      required: false,
      default: "get"
    },
    list: {
      type: Array,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    property: {
      type: String,
      required: false,
      default: "name"
    },
    inputClass: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    ignoreCase: {
      type: Boolean,
      required: false,
      default: true
    },
    threshold: {
      type: Number,
      required: false,
      default: 0
    },
    value: {
      required: false,
      default: ""
    },
    autoHide: {
      type: Boolean,
      required: false,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    list(value) {
      this.entries = value;
      this.search = "";
      this.selectedIndex = 0;
    },
    // filteredEntries(value) {
    //   if (this.selectedIndex > value.length - 1) {
    //     this.selectedIndex = 0;
    //   }
    // },
    search(value, oldValue) {
      this.$emit("input", value);
    },
    value(newValue) {
      this.search = newValue;
    }
  }
};
</script>
<style lang="scss" scoped>
.error {
  color: #f44336 !important;
}
.autocomplete {
  position: relative;
  input {
    width: 100%;
  }
}
.autocomplete__suggestions {
  position: absolute;
  top: 36px;
  background-color: #fff;
  width: 100%;
  max-height: 300px;
  z-index: 2;
  overflow: hidden;
  overflow-y: scroll;
  border: 1px solid darken(#43a047, 5%);
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  text-align: left;
}

.autocomplete__entry {
  padding: 10px;
  &:hover {
    background-color: #43a047;
    color: #fff;
    cursor: default;
    font-weight: bold;
  }
}

.autocomplete__selected {
  background-color: darken(#43a047, 5%);
  color: #fff;
  font-weight: bold;
}
</style>
